import publicAxios, { API_URL } from './PublicAxios';

/**
 * Serviço para chamadas à API pública de pedidos.
 * Não requer autenticação.
 */

/**
 * Obtém informações da empresa para pedido público.
 * @param {string} companyUuid - UUID da empresa
 * @returns {Promise} - Dados da empresa com filiais
 */
export const getCompanyInfo = (companyUuid) => {
    return publicAxios.get(`/api/order/${companyUuid}`);
};

/**
 * Lista produtos de uma filial.
 * @param {string} companyUuid - UUID da empresa
 * @param {number} branchId - ID da filial
 * @returns {Promise} - Lista de produtos
 */
export const getProductsByBranch = (companyUuid, branchId) => {
    return publicAxios.get(`/api/order/${companyUuid}/branch/${branchId}/products`);
};

/**
 * Busca um cliente pelo CPF/documento.
 * @param {string} companyUuid - UUID da empresa
 * @param {string} document - CPF/documento do cliente
 * @returns {Promise} - Dados do cliente (404 se não encontrado)
 */
export const lookupCustomerByDocument = (companyUuid, document) => {
    return publicAxios.get(`/api/order/${companyUuid}/customers/lookup`, { params: { document } });
};

/**
 * Cria um novo pedido público.
 * @param {string} companyUuid - UUID da empresa
 * @param {object} orderData - Dados do pedido
 * @returns {Promise} - Dados do pedido criado
 */
export const createOrder = (companyUuid, orderData) => {
    return publicAxios.post(`/api/order/${companyUuid}/orders`, orderData);
};

/**
 * Busca um pedido pelo UUID.
 * @param {string} companyUuid - UUID da empresa
 * @param {string} orderUuid - UUID do pedido
 * @param {string} document - CPF/documento do cliente para validação
 * @returns {Promise} - Dados do pedido
 */
export const getOrderByUuid = (companyUuid, orderUuid, document) => {
    return publicAxios.get(`/api/order/${companyUuid}/orders/${orderUuid}`, { params: { document } });
};

export const getProductImageUrl = (companyUuid, productId) => {
    return `${API_URL}/api/order/${companyUuid}/product/${productId}/image`;
};
